<!-- @format -->

<ng-container *transloco="let t">
  <fudis-expandable [level]="2" [title]="t('FREE_EDIT.CUSTOM_STUDY_DRAFT_EXPANDABLE.TITLE')" [closed]="false">
    <ng-template fudisExpandableContent>
      <fudis-body-text>{{ t("FREE_EDIT.CUSTOM_STUDY_DRAFT_EXPANDABLE.CUSTOM_STUDY_DRAFTS_INFORMATION") }}</fudis-body-text>
      <sis-button
        [label]="t('FREE_EDIT.CUSTOM_STUDY_DRAFT_EXPANDABLE.CUSTOM_STUDY_DRAFTS_READ_MORE')"
        (clicked)="openReadMoreAboutStudyDraftModal()"
        [link]="true">
      </sis-button>
      <div class="sis-pt-md sis-pb-xs">
        <fudis-button
          [label]="t('FREE_EDIT.CUSTOM_STUDY_DRAFT_EXPANDABLE.ADD_NEW_CUSTOM_STUDY_DRAFT')"
          [variant]="'secondary'"
          [size]="'small'"
          [disabled]="false"
          (handleClick)="openAddStudyDraftModal.emit()"></fudis-button>
      </div>
      @for (customStudyDraft of allCustomStudyDrafts(); track customStudyDraft) {
        <div class="sis-pt-sm">
          @let isInPlan = !!selectedCustomStudyDraftsById()[customStudyDraft.id];
          <sis-study-box
            [type]="StudyBoxType.studyDraft"
            [selected]="isInPlan"
            [action]="'select-to-plan'"
            (actionChange)="toggleCustomStudyDraft.emit({ customStudyDraft, isInPlan })"
            [id]="customStudyDraft.id"
            [name]="customStudyDraft.name"
            [credits]="{ max: customStudyDraft.credits, min: customStudyDraft.credits }">
          </sis-study-box>
        </div>
      }
    </ng-template>
  </fudis-expandable>
</ng-container>
